module.exports = __webpack_public_path__ + "static/media/dreidel.8719849a.svg";